import BaseError from './base-error'

class UnsupportedTypeError extends BaseError {
}

export default UnsupportedTypeError
